import Address from "./Address/Address"

const MantineForm = {
    Address,
}

export default MantineForm;